<div class="card card-statistics mb-30">
  <div class="card-body">
      <h5 class="card-title">Register New Instrument Score Condition</h5>
      <form [formGroup]="AddNewDeviceCondition" (submit)="SubmitAddNewDeviceCondition()">

        <input type="hidden" formControlName="id" />

        <div class="row">
          <div class="form-group col-md-6">
            <label for="exampleInputEmail1">Days</label>
            <input formControlName="day" type="number" class="form-control"  placeholder="Type here...">
            <small *ngIf="!get_Form_day().valid && get_Form_day().touched" class="form-text text-muted MyErrorRedColor">Please enter the number of days.</small>
          </div>
          <div class="form-group col-md-6">
            <label for="exampleInputEmail1">Late</label>
            <input formControlName="takhir" type="number" class="form-control"  placeholder="Type here...">
            <small *ngIf="!get_Form_takhir().valid && get_Form_takhir().touched" class="form-text text-muted MyErrorRedColor">Please enter the late-delivery score.</small>
          </div>
        </div>
        <div class="row">
          <div class="form-group col-md-6">
            <label for="exampleInputEmail1">Early</label>
            <input formControlName="tajil" type="number" class="form-control"  placeholder="Type here...">
            <small *ngIf="!get_Form_tajil().valid && get_Form_tajil().touched" class="form-text text-muted MyErrorRedColor">Please enter the early-delivery score.</small>
          </div>
          <div class="form-group col-md-6">
            <label for="exampleInputEmail1">On Time</label>
            <input formControlName="brabar" type="number" class="form-control"  placeholder="Type here...">
            <small *ngIf="!get_Form_brabar().valid && get_Form_brabar().touched" class="form-text text-muted MyErrorRedColor">Please enter the on-time score.</small>
          </div>
        </div>
          <img *ngIf="InProccessing" src="assets/Loading.gif" style="width: 25px;" />
          <button *ngIf="!InProccessing" type="submit" [disabled]="!AddNewDeviceCondition.valid" class="btn btn-success" style="margin-right: 5px;"><i class="fa  fa-plus-circle"></i> Register Information </button>
          <button *ngIf="!InProccessing" type="reset" class="btn btn-danger" style="margin-right: 5px;"><i class="fa fa-times-rectangle" ></i> Cancel </button>
          <button routerLink="/DeviceCondition" *ngIf="!InProccessing" type="button" class="btn btn-warning"><i class="fa fa-mail-reply"></i> Back </button>
      </form>
  </div>
</div>

